import { useCallback } from "react";
import { useTranslation } from "@firecms/core";

import type { LocalizedString } from "./constants";
import { resolveLocalizedString } from "./resolveLocalizedString";

export function useResolveLocalizedString() {
  const { i18n } = useTranslation();

  return useCallback(
    (localized: LocalizedString | undefined, preferredLocale?: string) =>
      resolveLocalizedString(
        localized,
        preferredLocale,
        undefined,
        i18n.language
      ),
    [i18n.language]
  );
}
